import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { first } from 'rxjs/operators';
import { StreamService } from "../services/stream.service";
import { BehaviorSubject, Subject, from } from "rxjs";
import * as _ from 'lodash';

@Component({
    selector: 'topic-builder-sources',
    styles: [`
        .resultWrapper {
            overflow-y: auto;
            max-height: calc(100vh - 285px);
        }
    `],
    template: `
        <div *ngIf="noTouching" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner syle="padding-top: 100px;"></spinner>
        </div>
        <div *ngIf="!noTouching" 
             class="resultWrapper" 
             infiniteScroll
             [infiniteScrollDisabled]="noMorePages"
             [scrollWindow]="false"
             (scrolled)="nextPage()">
             <table mat-table *ngIf="sourceResults" #table [dataSource]="sourceResults" fxFlex>
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef>Source</th>
                    <td mat-cell *matCellDef="let row">
                        <div style="overflow: hidden; white-space: nowrap;">
                            <div style="text-overflow: ellipsis; overflow: hidden;" [matTooltip]="row.title">{{row.title}}</div>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="count">
                    <th mat-header-cell *matHeaderCellDef>Items</th>
                    <td mat-cell *matCellDef="let row" width="120">
                        {{ sourceCounts[row.id] }}
                    </td>
                </ng-container>
                
                <tr mat-header-row *matHeaderRowDef="['title', 'count']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['title', 'count'];"
                    class="item-summary"></tr>
            </table>
        </div>
    `
})
export class TopicBuilderSourcesComponent implements OnChanges, OnDestroy {
    @Input() sources;
    cleanupTime = new Subject<void>();
    sourceResults = new BehaviorSubject<any[]>([]);
    noTouching: boolean;
    page = 0;
    pageSize = 30;
    noMorePages: boolean;
    sourceCounts: any;

    constructor(private streamService: StreamService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.sourceResults.next([]);        
        if (changes.sources.currentValue && changes.sources.currentValue.length) {
            this.sourceCounts = _.reduce(this.sources, (accum, aggr) => { 
                accum[aggr.key] = aggr.doc_count; 
                return accum; 
            } , {})
            this.page == 0;
            this.fetchPage();
            this.noMorePages = false;
            this.noTouching = true;
            this.cleanupTime.next();   
        }
    }

    nextPage() {
        if (!this.noMorePages) {
            this.page++;
            this.fetchPage();
        }
    }

    fetchPage() {
        const startIndex = this.page * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.noMorePages = endIndex > this.sources.length;
        this.sources.slice(startIndex, endIndex).map(aggr => 
            this.streamService.getStream(aggr.key).pipe(first())
            .subscribe(stream => {
                this.noTouching = false;
                this.sourceResults.next(this.sourceResults.value.concat(stream));
            })
        );
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
        this.sourceResults.complete();
    }
}